module.exports = __webpack_public_path__ + "static/media/value-prop-icon-4.b7b82cfd.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-WEB/value-prop-icon-4.svg
// module id = 1430
// module chunks = 0